export var elements = {
    // General
    buttons: {
        primary: {},
        outline: {},
        standard: {}
    }
};
